<script setup lang="ts">
const { locale } = useI18n()

function getLocalizedPdfFile(filePath: string): string {
  return `${filePath}_${locale.value}.pdf`
}
</script>

<template>
  <section class="mt-16 pb-16">
    <div
      class="container max-w-xl px-4 md:max-w-3xl lg:max-w-3xl xl:max-w-4xl"
    >
      <h2
        class="font-pragmatica-ext mb-4 text-[calc(1.375rem+1.5vw)] font-bold !leading-none xl:text-4xl"
      >
        {{ $t('forCustomers.sales-conditions.title') }}
      </h2>
      <UiButtonDownload
        :file-path="
          getLocalizedPdfFile(
            '/pdf/sales-conditions/sales-conditions-LD-Seating-2024'
          )
        "
        label-path="forCustomers.downloadAsPdf"
      />
    </div>
  </section>
</template>

<style scoped></style>
